var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessory = function SvgAccessory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accessory_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.85 21.203 2.955-4.523 5.438 7.45-5.317 1.808"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m32.85 21.203 2.955-4.523 5.438 7.45-5.317 1.808"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m35.933 25.938-3.083-4.73-4.093 2.796a11.3 11.3 0 0 0-3.073-2.254v-9.3h.725a1.9 1.9 0 0 0 1.353-.576 1.99 1.99 0 0 0 .415-2.139 2 2 0 0 0-.415-.637 1.9 1.9 0 0 0-.62-.425 1.9 1.9 0 0 0-.733-.15H15.304a1.9 1.9 0 0 0-1.354.575 2 2 0 0 0-.56 1.388c0 .521.201 1.02.56 1.388a1.9 1.9 0 0 0 1.354.575h.823v9.301a11.2 11.2 0 0 0-4.743 4.374 11.63 11.63 0 0 0-1.62 6.327 11.72 11.72 0 0 0 3.366 7.717 11.15 11.15 0 0 0 7.582 3.314c1.48.026 2.95-.25 4.326-.812a11.1 11.1 0 0 0 3.683-2.465 11.5 11.5 0 0 0 2.467-3.734c.573-1.4.867-2.904.867-4.422a11.6 11.6 0 0 0-.442-3.155z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.929 37.146c1.322-1.248 4.538-2.578 11.606-.64 7.069 1.94 8.877-.638 8.877-.638m-16.138-4.717a.8.8 0 0 0 .228.565.77.77 0 0 0 .55.234.77.77 0 0 0 .551-.234.81.81 0 0 0 0-1.13.77.77 0 0 0-.55-.233.77.77 0 0 0-.551.233.8.8 0 0 0-.228.565m3.666-4.812c0 .212.082.415.228.564a.77.77 0 0 0 1.1 0 .81.81 0 0 0 0-1.13.77.77 0 0 0-1.101 0 .8.8 0 0 0-.227.566m3.9 5.611a.8.8 0 0 0 .228.564.77.77 0 0 0 1.102 0 .81.81 0 0 0 0-1.13.77.77 0 0 0-1.102 0 .8.8 0 0 0-.228.566"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accessory_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgAccessory;